module.exports = __webpack_public_path__ + "img/img-3-11mobile.2fc01a9e.png";